module.exports = __webpack_public_path__ + "img/metamask.04a373f4.svg";